import _ from "lodash";
import client from "client/client";
import {
    CONTENTS_CHECK,
    DISCARD,
    EVENTS,
    PUBLISH,
    CONTENTS,
    EVALUATIONQUESTION,
    CHANGE_ORDER,
    RESTORE,
    EVALUATIONQUESTION_CHECK,
    MEDIA,
    ATTACH,
    DETACH,
    CERTIFICATES,
    CHANNELS,
    BUSY_COUNTRIES,
    LAYOUTS,
    AGENDAS,
    SPEAKERS,
    TOGGLE,
    CALENDARS,
    REMINDERS,
    DOWNLOAD_ICS,
    USERS,
    LOGGED,
    TEST_REMINDER,
    THEMES,
    SET_THEME,
    CSS_MEDIA,
    SAVE_UPLOADED,
    EPISODES,
    LIVE_START,
    LIVE_END,
    DOWNLOAD_CERTIFICATE,
    EMAIL_CERTIFICATE,
    LEGALS,
    LOGOUT,
    MAILERS,
    FAQS,
    SUBSCRIPTIONS,
    IMPORT_SUBSCRIPTIONS,
    TOGGLE_INTERNAL,
    SEND_REGISTRATION_EMAIL,
    IMPORTS,
    TRACKING_START,
    TRACKING_END,
    EXPORT_SUBSCRIPTIONS,
    SUBSCRIBE_TO_CHANNELS,
    CHANGE_SUBSCRIPTION_TYPE,
    CHANGE_QAA_STATUS,
    CHANNELS_STATUS,
    EVALUATIONQUESTIONSCATEGORIES,
    FORCE_USERS_LOGOUT,
    SHARE,
    REPORTS,
    REFRESH_REPORTS,
    DOWNLOAD_REPORTS,
    IMPORT_CONFIG,
    EXPORT_CONFIG,
    SUBSCRIPTION_ANALYTICS,
    CERTIFICATELOGS,
    UPDATE_CONNECTED_USERS,
    COUNTRIES,
    AWS_APPS,
    DOMAINS,
    ASSOCIATION,
    PLAYER_CALENDAR,
    CLEAN_QAA,
    LOGS,
    SUPPRESSION_LIST,
    EPISODE_CATEGORIES,
    ATTACHMENTS,
    EPISODE_TABS,
    SORT,
    BLACKBOX,
    ADMIN_ACCESS_LOG,
    WAITING_ROOMS,
    ACCEPT,
    REJECT,
    GET_USERS,
    CERTIFICATE_LOG,
    FORCED_LOGOUT_LOG,
    CALENDAR_LOG,
    REGISTRATION_EMAIL_LOG,
    ROLES,
    JOBS_ERROR_LOG,
    ERROR_LOG,
    CHANNEL_SOURCES,
    CLOSED_CAPTIONS,
    TOGGLE_ACTIVE,
    PUBLISH_THEME_CHANGES,
    RESET_THEME_CHANGES,
    SET_THEME_VERSION,
    REGISTRATION_FORMS,
    USER_LOGIN_LOG,
    EMAIL_HISTORY_LOG,
    ANALYTICS,
    RESET_LIVE,
    REFRESH_LIVE,
    REFRESH_VOD,
    QUIZ_QUESTIONS,
    QUIZ_QUESTIONS_CATEGORIES,
    QUIZ_QUESTION_OPTIONS,
    CUSTOM_SUBSCRIPTIONS_LIST,
    DNS_LOOKUP,
    REFRESH_TOKEN,
    ATTACH_MEDIA,
    DETACH_MEDIA,
    CREATE_CERTIFICATE,
    DOWNLOADABLE,
    CONFIGS,
    ENUM,
    ROUTES_LIST,
    IMPORT,
    NOTIFICATIONS,
    REGISTERED_DOMAINS,
    PARKED_DOMAINS,
    ATTACHED_DOMAINS,
    ACTIVITY_LOGS,
    DOWNLOAD,
    SUBSCRIBER_NOTIFICATIONS,
    EXPORT_LOGINS,
    TICKETS,
    AVAILABLE_DOMAINS
} from "api/config/endpoints";
import { consoleLog, getIcsAttachemntParams } from "utils/functions";

export const buildQuery = (queryParams) => {
    const query = Object.keys(queryParams)
        .map((key) => {
            return (
                encodeURIComponent(key) +
                "=" +
                encodeURIComponent(queryParams[key])
            );
        })
        .join("&");
    return query;
};

export const getLanguages = async (force) => {
    const data = await getStorable("languages", force);
    return data;
};

export const getLiveCcLanguages = async (force) => {
    const availableLangs = await getLanguages(force);
    return availableLangs
        .filter((item) =>
            ["en", "es", "de", "it", "fr", "ko", "zh", "pt"].includes(item.id)
        )
        .map((item) => {
            return {
                ...item,
                label: `${item.label} (Live CC auto)`,
            };
        });
};

export const getTimezones = async (force) => {
    const data = await getStorable("timezones", force);
    return data;
};

export const getCountries = async (force) => {
    const data = await getStorable("countries", force);
    return data;
};

export const getAvailableDomains = async (eventId) => {
    const url = [AVAILABLE_DOMAINS].join("/");
    const res = await client.get(`${url}?event_id=${eventId}`);
    return _.get(res, "data.data");
};

// export const get2faQrCode = async () => {
//     const data = await client.get("2fa-qrcode")
//     return data
// }

export const check2faIsActive = async () => {
    const data = await client.get("2fa-active");
    return data;
};

export const getRegistrationForms = async () => {
    const url = [REGISTRATION_FORMS].join("/");
    const res = await client.get(`${url}`);
    return _.get(res, "data.data");
};

export const getDnsLookup = async (domains) => {
    const url = [DNS_LOOKUP].join("/");
    domains = domains.join(",");
    const res = await client.get(`${url}?domains=${domains}`);
    return _.get(res, "data.data");
};

export const getUser = async (userId) => {
    const id = userId || LOGGED;
    const res = await client.get([USERS, id].join("/"));
    return _.get(res, "data.data");
};

export const getUsers = async (params = {}) => {
    const query = buildQuery(params);
    const url = [USERS].join("/");
    const depth = params.paginate ? "data" : "data.data";
    const res = await client.get(`${url}?${query}`);
    return _.get(res, depth);
};

export const deleteUsers = async (userId) => {
    // const query = buildQuery(params);
    const id = userId
    const url = [
        USERS,
        id
    ].join("/")
    // const depth = params.paginate ? "data" : "data.data"
    const res = await client.delete(url);
    return _.get(res, "data")
}

export const getRoles = async (params = {}) => {
    const query = buildQuery(params);
    const url = [ROLES].join("/");
    const depth = params.paginate ? "data" : "data.data";
    const res = await client.get(`${url}?${query}`);
    return _.get(res, depth);
};

export const logout = async () => {
    const res = await client.post([LOGOUT].join("/"));
    return res;
};

export const getLogged = async () => {
    return await getUser();
};

export const getEvents = async (params) => {
    const query = buildQuery(params);
    const url = [EVENTS].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getEvent = async (eventId) => {
    const res = await client.get([EVENTS, eventId].join("/"));
    return _.get(res, "data.data");
};

export const updateEvent = async (eventId, queryParams) => {
    const query = buildQuery(queryParams);
    const url = [EVENTS, eventId].join("/");
    const res = await client.put(`${url}?${query}`);
    return _.get(res, "data.data");
};

export const setEventTheme = async (eventId, themeId) => {
    const url = [EVENTS, eventId, SET_THEME, themeId].join("/");
    const res = await client.post(`${url}`);
    return _.get(res, "data.data");
};

export const getDomains = async (params) => {
    const query = buildQuery(params);
    const url = [AWS_APPS, DOMAINS].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};


export const getRegisteredDomains = async (params) => {
    let query = null
    if (params) {
        query = buildQuery(params);
    }
    const url = [REGISTERED_DOMAINS].join("/");
    const res = await client.get(`${url}${query ? "?" + query : ''}`);
    return _.get(res, "data");
};

export const getParkedDomains = async (params) => {
    let query = null
    if (params) {
        query = buildQuery(params);
    }
    const url = [PARKED_DOMAINS].join("/");
    const res = await client.get(`${url}${query ? "?" + query : ''}`);
    return _.get(res, "data");
};

export const getAttachedDomains = async (params) => {
    let query = null
    if (params) {
        query = buildQuery(params);
    }
    const url = [ATTACHED_DOMAINS].join("/");
    const res = await client.get(`${url}${query ? "?" + query : ''}`);
    return _.get(res, "data");
};

export const getPlayerCalendars = async (params) => {
    const query = buildQuery(params);
    const url = [PLAYER_CALENDAR].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getAwsApps = async (params) => {
    const query = params ? buildQuery(params) : "";
    const url = [AWS_APPS].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data.data");
};

// export const createDomainAssociation = async (params) => {

//     const url = [
//         AWS_APPS,
//         DOMAINS,
//         ASSOCIATION
//     ].join("/")
//     const res = await client.post(`${url}`, params);
//     return _.get(res, "data")
// }

export const deleteDomainAssociation = async (params) => {
    const query = buildQuery(params);
    const url = [AWS_APPS, DOMAINS, ASSOCIATION].join("/");
    const res = await client.delete(`${url}?${query}`);
    return _.get(res, "data");
};

export const getChannelSpeakers = async (channelId, params) => {
    const query = params ? buildQuery(params) : "";
    const url = [CHANNELS, channelId, SPEAKERS].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getChannelSources = async ({ channelId, event }, params) => {
    const query = params ? buildQuery(params) : "";
    const url = [EVENTS, event, CHANNELS, channelId, CHANNEL_SOURCES].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getClosedCaptions = async ({ channelId, event }, params) => {
    const query = params ? buildQuery(params) : "";
    const url = [EVENTS, event, CHANNELS, channelId, CLOSED_CAPTIONS].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const changeChannelSourcesOrder = async (
    { channelId, event },
    params
) => {
    const url = [EVENTS, event, CHANNELS, channelId, CHANNEL_SOURCES].join("/");
    const res = await client.post(`${url}`, params);
    return _.get(res, "data");
};

export const deleteChannelSources = async (
    { channelId, event, channelSourceId },
    params
) => {
    const url = [
        EVENTS,
        event,
        CHANNELS,
        channelId,
        CHANNEL_SOURCES,
        channelSourceId,
    ].join("/");
    const res = await client.delete(`${url}`, params);
    return _.get(res, "data");
};

export const deleteClosedCaptions = async (
    { channelId, event, closedCaptionId },
    params
) => {
    const url = [
        EVENTS,
        event,
        CHANNELS,
        channelId,
        CLOSED_CAPTIONS,
        closedCaptionId,
    ].join("/");
    const res = await client.delete(`${url}`, params);
    return _.get(res, "data");
};

export const toggleClosedCaptionActive = async (
    { channelId, event, closedCaptionId },
    params
) => {
    const url = [
        EVENTS,
        event,
        CHANNELS,
        channelId,
        CLOSED_CAPTIONS,
        closedCaptionId,
        TOGGLE_ACTIVE,
    ].join("/");
    const res = await client.post(`${url}`, params);
    return _.get(res, "data");
};

export const sortChannelSources = async ({ channelId, event }, params) => {
    const url = [
        EVENTS,
        event,
        CHANNELS,
        channelId,
        CHANNEL_SOURCES,
        SORT,
    ].join("/");
    const res = await client.post(`${url}`, params);
    return _.get(res, "data");
};

export const sortClosedCaptions = async ({ channelId, event }, params) => {
    const url = [
        EVENTS,
        event,
        CHANNELS,
        channelId,
        CLOSED_CAPTIONS,
        SORT,
    ].join("/");
    const res = await client.post(`${url}`, params);
    return _.get(res, "data");
};

export const getEpisodeSpeakers = async (channelId, params) => {
    const query = params ? buildQuery(params) : "";
    const url = [EPISODES, channelId, SPEAKERS].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getEpisodeSubscriptionsAnalytics = async (episodeId, params) => {
    const query = params ? buildQuery(params) : "";
    const url = [EPISODES, episodeId, ANALYTICS].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const checkContentsStatus = async (eventId, params) => {
    const query = params ? `?${buildQuery(params)}` : "";
    const res = await client.get(
        [EVENTS, eventId, CONTENTS_CHECK].join("/") + query
    );
    return _.get(res, "data.data");
};

export const checkEvaluationQuestionsStatus = async (eventId, episodeId) => {
    const query = episodeId
        ? `?${buildQuery({
            episode_id: episodeId,
        })}`
        : "";
    const url = [EVENTS, eventId, EVALUATIONQUESTION_CHECK].join("/");
    const res = await client.get(`${url}${query}`);
    return _.get(res, "data.data");
};

export const checkCertificatesReminderEmailStatus = async (eventId, params) => {
    return await checkContentsStatus(eventId, params);
};

export const setEpisodeAttachments = async (eventId, episodeId, params) => {
    // events/{event}/episodes/{episode}/attachments
    const endpoint = [EVENTS, eventId, EPISODES, episodeId, ATTACHMENTS].join(
        "/"
    );
    const res = await client.post(`${endpoint}`, params);
    return res.data;
};

export const setEpisodeIcsMeetTheExpertsAttachemnts = async (
    eventId,
    episodeId,
    params
) => {
    const res = await setEpisodeAttachments(eventId, episodeId, {
        ...params,
        ...getIcsAttachemntParams(),
    });
    return res;
};

export const getEpisodeAttachments = async (eventId, episodeId, params) => {
    const query = params ? `?${buildQuery(params)}` : "";
    const endpoint = [EVENTS, eventId, EPISODES, episodeId, ATTACHMENTS].join(
        "/"
    );
    const res = await client.get(`${endpoint}${query}`);
    return res.data;
};

export const getEpisodeIcsMeetTheExpertsAttachemnts = async (
    eventId,
    episodeId,
    params
) => {
    const res = await getEpisodeAttachments(eventId, episodeId, {
        ...params,
        ...getIcsAttachemntParams(),
    });
    return res;
};

export const deleteEpisodeAttachments = async (
    eventId,
    episodeId,
    mediaId,
    params
) => {
    const query = params ? `?${buildQuery(params)}` : "";
    const endpoint = [
        EVENTS,
        eventId,
        EPISODES,
        episodeId,
        ATTACHMENTS,
        mediaId,
    ].join("/");
    const res = await client.delete(`${endpoint}${query}`);
    return res.data;
};

export const removeEpisodeIcsMeetTheExpertsAttachemnts = async (
    eventId,
    episodeId,
    mediaId,
    params
) => {
    const res = await deleteEpisodeAttachments(eventId, episodeId, mediaId, {
        ...params,
        ...getIcsAttachemntParams(),
    });
    return res;
};

export const getCalendarAttachments = async ({
    eventId,
    reminderId,
    params,
}) => {
    //events/{event}/reminders/{reminder}/attach-media
    const query = params ? `?${buildQuery(params)}` : "";
    const url = [EVENTS, eventId, REMINDERS, reminderId, ATTACH_MEDIA].join(
        "/"
    );
    const res = await client.get(`${url}${query}`);
    return _.get(res, "data.data");
};

export const setCalendarAttachments = async ({
    eventId,
    reminderId,
    params,
}) => {
    // events/{event}/episodes/{episode}/attachments
    const endpoint = [
        EVENTS,
        eventId,
        REMINDERS,
        reminderId,
        ATTACH_MEDIA,
    ].join("/");
    const res = await client.post(`${endpoint}`, params);
    return _.get(res, "data.data");
};

// Episodes
export const getEventEpisodes = async (eventId) => {
    const url = [EVENTS, eventId, EPISODES].join("/");
    const res = await client.get(url);
    return _.get(res, "data.data");
};
export const deleteEpisode = async (eventId, episodeId) => {
    const endpoint = [EVENTS, eventId, EPISODES, episodeId].join("/");
    const res = await client.delete(`${endpoint}`);
    return res.data;
};
export const deleteEpisodeQaA = async (episodeId, params) => {
    const endpoint = [EPISODES, episodeId, CLEAN_QAA].join("/");
    const res = await client.post(`${endpoint}`, params);
    return res.data;
};

export const getEpisodeCategories = async (eventId) => {
    const endpoint = [EVENTS, eventId, EPISODE_CATEGORIES].join("/");
    const res = await client.get(`${endpoint}`);
    return _.get(res, "data.data");
};

// Contents
export const getContents = async (eventId, section, queryParams) => {
    const query = buildQuery(queryParams);
    const endpoint = [EVENTS, eventId, section].join("/");
    const res = await client.get(`${endpoint}?${query}`);
    return res.data;
};

export const publish = async (eventId, queryParams, model) => {
    const query = buildQuery(queryParams);
    const endpoint = [EVENTS, eventId, model, PUBLISH].join("/");
    const res = await client.post(`${endpoint}?${query}`);
    return res.data;
};

export const discard = async (eventId, queryParams, model) => {
    const query = buildQuery(queryParams);
    const endpoint = [EVENTS, eventId, model, DISCARD].join("/");
    const res = await client.post(`${endpoint}?${query}`);
    return res.data;
};

export const publishContents = async (eventId, queryParams) => {
    const query = buildQuery(queryParams);
    const endpoint = [EVENTS, eventId, CONTENTS, PUBLISH].join("/");
    const res = await client.post(`${endpoint}?${query}`);
    return res.data;
};

export const discardContents = async (eventId, queryParams) => {
    const query = buildQuery(queryParams);
    const endpoint = [EVENTS, eventId, CONTENTS, DISCARD].join("/");
    const res = await client.post(`${endpoint}?${query}`);
    return res.data;
};

// ICS
export const downloadEventIcs = async (eventId, episodeId, queryParams) => {
    const query = buildQuery(queryParams);
    const endpoint = [EVENTS, eventId, EPISODES, episodeId, DOWNLOAD_ICS].join(
        "/"
    );
    const res = await client.get(`${endpoint}?${query}`);
    return res.data;
};

// Evaluation questions
export const getEvaluationquestions = async (eventId, queryParams) => {
    const query = buildQuery(queryParams);
    const endpoint = [EVENTS, eventId, EVALUATIONQUESTION].join("/");
    const res = await client.get(`${endpoint}?${query}`);
    return res.data;
};

export const createEvaluationquestions = async ({
    eventId,
    ...queryParams
}) => {
    const query = buildQuery(queryParams);
    const endpoint = [EVENTS, eventId, EVALUATIONQUESTION].join("/");
    const res = await client.post(`${endpoint}?${query}`);
    return res.data;
};

export const publishEvaluationquestions = async (eventId, queryParams) => {
    const query = buildQuery(queryParams);
    const endpoint = [EVENTS, eventId, EVALUATIONQUESTION, PUBLISH].join("/");
    const res = await client.post(`${endpoint}?${query}`);
    return res.data;
};

export const discardEvaluationquestions = async (eventId, queryParams) => {
    const query = buildQuery(queryParams);
    const endpoint = [EVENTS, eventId, EVALUATIONQUESTION, DISCARD].join("/");
    const res = await client.post(`${endpoint}?${query}`);
    return res.data;
};

export const changeOrderdEvaluationquestions = async (
    eventId,
    queryParams,
    order
) => {
    const query = buildQuery(queryParams);
    const endpoint = [EVENTS, eventId, EVALUATIONQUESTION, CHANGE_ORDER].join(
        "/"
    );
    const res = await client.post(`${endpoint}?${query}`, order);
    return res.data;
};

export const deleteEvaluationquestions = async (eventId, eqId) => {
    const endpoint = [EVENTS, eventId, EVALUATIONQUESTION, eqId].join("/");
    const res = await client.delete(`${endpoint}`);
    return res.data;
};

export const restoreEvaluationquestions = async (eqId) => {
    const endpoint = [EVALUATIONQUESTION, eqId, RESTORE].join("/");
    const res = await client.post(`${endpoint}`);
    return res.data;
};

// Quiz categories
export const getQuizCategories = async (episodeId) => {
    const url = [EPISODES, episodeId, QUIZ_QUESTIONS_CATEGORIES].join("/");
    const res = await client.get(`${url}`);
    return _.get(res, "data.data");
};

export const getQuizCategory = async (categoryId) => {
    const url = [QUIZ_QUESTIONS_CATEGORIES, categoryId].join("/");
    const res = await client.get(url);
    return _.get(res, "data.data");
};

export const deleteQuizCategory = async (categoryId) => {
    const url = [QUIZ_QUESTIONS_CATEGORIES, categoryId].join(
        "/"
    );
    const res = await client.delete(url);
    return _.get(res, "data");
};

export const changeOrderdQuizQuestionCategories = async ({
    episodeId,
    order,
}) => {
    const endpoint = [
        EPISODES,
        episodeId,
        QUIZ_QUESTIONS_CATEGORIES,
        CHANGE_ORDER,
    ].join("/");
    const res = await client.post(`${endpoint}`, { order });
    return res.data;
};

// Quiz questions
export const getQuizQuestionsByCategory = async (
    categoryId,
    queryParams = {}
) => {
    const query = buildQuery(queryParams);
    const endpoint = [
        QUIZ_QUESTIONS_CATEGORIES,
        categoryId,
        QUIZ_QUESTIONS,
    ].join("/");
    const res = await client.get(`${endpoint}?${query}`);
    return res.data;
};
export const getQuizQuestion = async (questionId, queryParams) => {
    const query = buildQuery(queryParams);
    const endpoint = [QUIZ_QUESTIONS, questionId].join("/");
    const res = await client.get(`${endpoint}?${query}`);
    return res.data;
};

export const createQuizQuestion = async ({ categoryId, ...queryParams }) => {
    const endpoint = [
        QUIZ_QUESTIONS_CATEGORIES,
        categoryId,
        QUIZ_QUESTIONS,
    ].join("/");
    const res = await client.post(`${endpoint}`, queryParams);
    return res.data;
};

export const changeOrderdQuizQuestions = async ({ categoryId, order }) => {
    const endpoint = [
        QUIZ_QUESTIONS_CATEGORIES,
        categoryId,
        QUIZ_QUESTIONS,
        CHANGE_ORDER,
    ].join("/");
    const res = await client.post(`${endpoint}`, { order });
    return res.data;
};

export const getQuizQuestionOptions = async ({
    questionId,
    ...queryParams
}) => {
    const query = queryParams ? `?${buildQuery(queryParams)}` : "";
    const endpoint = [QUIZ_QUESTIONS, questionId, QUIZ_QUESTION_OPTIONS].join(
        "/"
    );
    const res = await client.get(`${endpoint}${query}`);
    return res.data;
};

export const deleteQuizQuestions = async (eqId) => {
    const endpoint = [QUIZ_QUESTIONS, eqId].join("/");
    const res = await client.delete(`${endpoint}`);
    return res.data;
};

export const changeOrderdQuizQuestionOptions = async ({
    questionId,
    order,
}) => {
    const endpoint = [
        QUIZ_QUESTIONS,
        questionId,
        QUIZ_QUESTION_OPTIONS,
        CHANGE_ORDER,
    ].join("/");
    const res = await client.post(`${endpoint}`, { order });
    return res.data;
};

export const deleteQuizQuestionOptions = async (id) => {
    const endpoint = [QUIZ_QUESTION_OPTIONS, id].join("/");
    const res = await client.delete(`${endpoint}`);
    return res.data;
};

// Certificate
export const getCertificate = async ({ certificateId }) => {
    const endpoint = [CERTIFICATES, certificateId].join("/");
    const res = await client.get(`${endpoint}`);
    return _.get(res, "data.data");
};

export const getEventTickets = async (eventId) => {
    const endpoint = [EVENTS, eventId, TICKETS].join("/");
    const res = await client.get(`${endpoint}`);
    return _.get(res, "data.data");
};

export const getEventSingleTicket = async (eventId, ticketId) => {
    const endpoint = [EVENTS, eventId, TICKETS, ticketId].join("/");
    const res = await client.get(`${endpoint}`);
    return _.get(res, "data.data");
};

export const deleteTicket = async (eventId, ticketId) => {
    const endpoint = [EVENTS, eventId, TICKETS, ticketId].join("/");
    const res = await client.delete(`${endpoint}`);
    return res.data;
};

export const downloadTicket = async (eventId, ticketId) => {
    const url = [EVENTS, eventId, TICKETS, ticketId, DOWNLOAD].join("/");
    const res = await client.get(`${url}`, {
        responseType: "blob"
    });
    return res.data;
}

export const updateTicket = async (eventId, ticketId, params) => {
    const url = [EVENTS, eventId, TICKETS, ticketId].join("/");
    const res = await client.put(`${endpoint}`, params);
    return res.data;
}

export const createTicket = async (eventId, params) => {
    const url = [EVENTS, eventId, TICKETS].join("/");
    const res = await client.post(`${endpoint}`, params);
    return res.data;
}


// @deprecated
export const getCertificateByEvent = async (eventId, eventType, episodeId) => {
    const query = eventType
        ? "?" +
        buildQuery({
            event_type: eventType,
            episode_id: episodeId,
        })
        : "";
    const endpoint = [EVENTS, eventId, CERTIFICATES].join("/");
    const res = await client.get(`${endpoint}${query}`);
    return _.get(res, "data.data");
};

// @deprecated
export const getEventCertificates = async (eventId, queryParams) => {
    const query = queryParams ? `?${buildQuery(queryParams)}` : "";
    const endpoint = [EVENTS, eventId, CERTIFICATES].join("/");
    const res = await client.get(`${endpoint}${query}`);
    return _.get(res, "data.data");
};

export const getEpisodeCertificates = async ({
    episodeId,
    queryParams = null,
}) => {
    queryParams = {
        ...queryParams,
        with_trashed: 1,
    };
    const query = queryParams ? `?${buildQuery(queryParams)}` : "";
    const endpoint = [EPISODES, episodeId, CERTIFICATES].join("/");
    const res = await client.get(`${endpoint}${query}`);
    return _.get(res, "data.data");
};

export const downloadCertificate = async (certificateId, queryParams) => {
    const query = buildQuery(queryParams);
    const endpoint = [CERTIFICATES, certificateId, DOWNLOAD_CERTIFICATE].join(
        "/"
    );
    const res = await client.get(`${endpoint}?${query}`, {
        responseType: "blob",
    });
    return res.data;
};

export const deleteCertificate = async (certificateId, queryParams = {}) => {
    const query = buildQuery(queryParams);
    const endpoint = [CERTIFICATES, certificateId].join("/");
    const res = await client.delete(`${endpoint}?${query}`);
    return res.data;
};
export const restoreCertificate = async (certificateId, queryParams = {}) => {
    const query = buildQuery(queryParams);
    const endpoint = [CERTIFICATES, certificateId, RESTORE].join("/");
    const res = await client.post(`${endpoint}?${query}`);
    return res.data;
};

export const getCertificateLogs = async (eventId, queryParams) => {
    const query = queryParams ? buildQuery(queryParams) : "";
    const endpoint = [EVENTS, eventId, CERTIFICATELOGS].join("/");
    const res = await client.get(`${endpoint}?${query}`);
    return window._.get(res, "data.data");
};

export const generateCoaPdf = async ({
    subscriprionId,
    eventId,
    channelId,
    eventType,
}) => {
    const queryParams = {
        channel_id: channelId,
        event_type: eventType,
    };
    const endpoint = [
        EVENTS,
        eventId,
        SUBSCRIPTIONS,
        subscriprionId,
        CREATE_CERTIFICATE,
    ].join("/");
    const res = await client.post(`${endpoint}`, queryParams);
    return window._.get(res, "data.data");
};

export const getEventCountries = async (eventId) => {
    const endpoint = [EVENTS, eventId, COUNTRIES].join("/");
    const res = await client.get(`${endpoint}`);
    return window._.get(res, "data.data");
};

export const getChannelsStatus = async (eventId, episodeId) => {
    // const query = buildQuery(queryParams);
    const endpoint = [
        EVENTS,
        eventId,
        EPISODES,
        episodeId,
        CHANNELS_STATUS,
    ].join("/");
    const res = await client.get(`${endpoint}`);
    return res.data;
};

export const testCertificateEmail = async (certificateId, queryParams) => {
    const endpoint = [CERTIFICATES, certificateId, EMAIL_CERTIFICATE].join("/");
    const res = await client.post(`${endpoint}`, queryParams);
    return res.data;
};

// Episode
export const getEpisode = async (eventId, episodeId) => {
    const endpoint = [EVENTS, eventId, EPISODES, episodeId].join("/");
    const res = await client.get(`${endpoint}`);
    return _.get(res, "data.data");
};

export const startLive = async (eventId, episodeId) => {
    const endpoint = [EVENTS, eventId, EPISODES, episodeId, LIVE_START].join(
        "/"
    );
    const res = await client.post(`${endpoint}`);
    return _.get(res, "data.data");
};

export const stopLive = async (eventId, episodeId) => {
    const endpoint = [EVENTS, eventId, EPISODES, episodeId, LIVE_END].join("/");
    const res = await client.post(`${endpoint}`);
    return _.get(res, "data.data");
};

export const startTracking = async (eventId, episodeId) => {
    const endpoint = [
        EVENTS,
        eventId,
        EPISODES,
        episodeId,
        TRACKING_START,
    ].join("/");
    const res = await client.post(`${endpoint}`);
    return _.get(res, "data.data");
};

export const stopTracking = async (eventId, episodeId) => {
    const endpoint = [EVENTS, eventId, EPISODES, episodeId, TRACKING_END].join(
        "/"
    );
    const res = await client.post(`${endpoint}`);
    return _.get(res, "data.data");
};

export const resetLive = async (eventId, episodeId) => {
    const endpoint = [EVENTS, eventId, EPISODES, episodeId, RESET_LIVE].join(
        "/"
    );
    const res = await client.post(`${endpoint}`);
    return _.get(res, "data.data");
};

export const repushLive = async ({ eventId, episodeId }) => {
    const endpoint = [EVENTS, eventId, EPISODES, episodeId, REFRESH_LIVE].join(
        "/"
    );
    const res = await client.post(`${endpoint}`);
    return _.get(res, "data");
};

export const _switchLiveMode = async ({ eventId, episodeId, mode }) => {
    const endpoint = [EVENTS, eventId, EPISODES, episodeId, REFRESH_LIVE].join(
        "/"
    );
    const res = await client.post(`${endpoint}`, { is_live_using_backup: mode });
    return _.get(res, "data");
};

export const repushVod = async ({ eventId, episodeId, keepCurrentTime }) => {
    const endpoint = [EVENTS, eventId, EPISODES, episodeId, REFRESH_VOD].join(
        "/"
    );
    const res = await client.post(`${endpoint}`, {
        keep_current_time: keepCurrentTime,
    });
    return _.get(res, "data");
};

// Episode tabs
export const getEpisodeTabs = async (episodeId) => {
    const endpoint = [EPISODES, episodeId, EPISODE_TABS].join("/");
    const res = await client.get(`${endpoint}`);
    return _.get(res, "data.data");
};
export const sortEpisodeTabs = async (episodeId, positions) => {
    const endpoint = [EPISODES, episodeId, EPISODE_TABS, SORT].join("/");
    const res = await client.post(`${endpoint}`, {
        positions,
    });
    return _.get(res, "data.data");
};
export const deleteEpisodeTab = async (episodeId, episodeTabId) => {
    const endpoint = [EPISODES, episodeId, EPISODE_TABS, episodeTabId].join(
        "/"
    );
    const res = await client.delete(`${endpoint}`);
    return _.get(res, "data.data");
};

// Waiting room
export const getEpisodeWaitingRoom = async (episodeId) => {
    const endpoint = [EPISODES, episodeId, WAITING_ROOMS].join("/");
    const res = await client.get(`${endpoint}`);
    return _.get(res, "data.data");
};

export const getWaitingRoomUsers = async (episodeId) => {
    const endpoint = [EPISODES, episodeId, WAITING_ROOMS, GET_USERS].join("/");
    const res = await client.get(`${endpoint}`);
    return _.get(res, "data.data");
};

export const acceptUsersFromWaitingRoom = async (params) => {
    const { episodeId } = params;
    const endpoint = [EPISODES, episodeId, WAITING_ROOMS, ACCEPT].join("/");
    const res = await client.post(`${endpoint}`, params);
    return _.get(res, "data.data");
};

export const rejectUsersFromWaitingRoom = async (params) => {
    const { episodeId } = params;
    const endpoint = [EPISODES, episodeId, WAITING_ROOMS, REJECT].join("/");
    const res = await client.post(`${endpoint}`, params);
    return _.get(res, "data.data");
};

export const deleteEpisodeWaitingRoom = async ({
    episodeId,
    waitingRoomId,
}) => {
    const endpoint = [EPISODES, episodeId, WAITING_ROOMS, waitingRoomId].join(
        "/"
    );
    const res = await client.delete(`${endpoint}`);
    return _.get(res, "data");
};

// QaA
export const enableQaa = async (eventId, episodeId, mode) => {
    let operation
    if (mode === "qaaStatus") {
        operation = { qaa_enabled: 1 }
    } else {
        operation = { is_public_qaa_open: 1 }
    }
    const endpoint = [
        EVENTS,
        eventId,
        EPISODES,
        episodeId,
        CHANGE_QAA_STATUS,
    ].join("/");
    const res = await client.post(`${endpoint}`, operation);
    return _.get(res, "data.data");
};

export const disableQaa = async (eventId, episodeId, mode) => {
    let operation
    if (mode === "qaaStatus") {
        operation = { qaa_enabled: 0 }
    } else {
        operation = { is_public_qaa_open: 0 }
    }
    const endpoint = [
        EVENTS,
        eventId,
        EPISODES,
        episodeId,
        CHANGE_QAA_STATUS,
    ].join("/");
    const res = await client.post(`${endpoint}`, operation);
    return _.get(res, "data.data");
};

// Media
export const saveMedia = async (params) => {
    const url = [MEDIA, SAVE_UPLOADED].join("/");
    const res = await client.post(url, params);
    return _.get(res, "data.data");
};

export const getMedia = async (eventId, params) => {
    params = {
        ...params,
        event_id: eventId,
    };
    const query = params ? "?" + buildQuery(params) : "";
    const url = [MEDIA].join("/");
    // const query = (eventId) ? `?event_id=${eventId}` : ""
    const res = await client.get(url + query);
    return _.get(res, "data.data");
};
export const findMedia = async (mediaId) => {
    const url = [MEDIA, mediaId].join("/");
    // const query = (eventId) ? `?event_id=${eventId}` : ""
    const res = await client.get(url);
    return _.get(res, "data.data");
};

export const deleteMedia = async (id) => {
    const endpoint = [MEDIA, id].join("/");
    const res = await client.delete(`${endpoint}`);
    return res.data;
};

export const attachMedia = async (id, params) => {
    const endpoint = [MEDIA, id, ATTACH].join("/");
    const res = await client.post(`${endpoint}`, params);
    return res.data;
};

export const detachMedia = async (id, params) => {
    const endpoint = [MEDIA, id, DETACH].join("/");
    const res = await client.post(`${endpoint}`, params);
    return res.data;
};

export const reminderDetachMedia = async ({ eventId, reminderId, params }) => {
    const endpoint = [
        EVENTS,
        eventId,
        REMINDERS,
        reminderId,
        DETACH_MEDIA,
    ].join("/");
    const res = await client.post(`${endpoint}`, params);
    return res.data;
};

// CSS MEDIA
//css-media
export const getCssMedia = async (eventId) => {
    const url = [EVENTS, eventId, CSS_MEDIA].join("/");
    // const query = (eventId) ? `?event_id=${eventId}` : ""
    const query = "";
    const res = await client.get(url + query);
    return _.get(res, "data.data");
};
export const getChannelCssMedia = async (channelId, _selectedLangCode) => {
    const url = [CHANNELS, channelId, CSS_MEDIA].join("/");
    // const query = (eventId) ? `?event_id=${eventId}` : ""
    const query = _selectedLangCode ? `?lang_id=${_selectedLangCode}` : "";
    const res = await client.get(url + query);
    return _.get(res, "data.data");
};

// Layout
export const getEventLayouts = async (eventId) => {
    const res = await client.get([EVENTS, eventId, LAYOUTS].join("/"));
    return _.get(res, "data.data");
};
export const getEventLayoutBySection = async (eventId, section) => {
    const query = section ? `?section=${section}` : "";
    const res = await client.get([EVENTS, eventId, LAYOUTS].join("/") + query);
    return _.get(res, "data.data");
};

// Channels
export const getEventChannels = async (eventId, params) => {
    const query = params ? "?" + buildQuery(params) : "";
    const url = [EVENTS, eventId, CHANNELS].join("/");
    const res = await client.get(`${url}${query}`);
    return _.get(res, "data.data");
};
export const getChannel = async (eventId, channelId) => {
    const url = [EVENTS, eventId, CHANNELS, channelId].join("/");
    const res = await client.get(url);
    return _.get(res, "data.data");
};

export const deleteChannel = async (eventId, channelId) => {
    const endpoint = [EVENTS, eventId, CHANNELS, channelId].join("/");
    const res = await client.delete(`${endpoint}`);
    return res.data;
};

export const _toggleInternal = async (eventId, channelId) => {
    const endpoint = [
        EVENTS,
        eventId,
        CHANNELS,
        channelId,
        TOGGLE_INTERNAL,
    ].join("/");
    const res = await client.post(`${endpoint}`);
    return res.data;
};

export const getBysyCountries = async ({
    eventId,
    episodeId,
    channelId,
    streamId,
}) => {
    let params = {};

    if (streamId) {
        params = {
            ...params,
            stream_id: streamId,
        };
    } else if (channelId) {
        params = {
            ...params,
            channel_id: channelId,
        };
    }
    let query = buildQuery(params);
    if (query) {
        query = "?" + query;
    }
    let chunks = [EVENTS, eventId, BUSY_COUNTRIES];

    if (episodeId) {
        chunks.push(episodeId);
    }
    const endpoint = chunks.join("/");
    const res = await client.get(`${endpoint}${query}`);
    return res.data;
};

// Agenda
/**
 * DO NOT USE IT
 * @param {@deprecated} channelId
 */
export const getChannelAgenda = async (channelId) => {
    ///events/927c6653-bce8-421f-a430-70db32cba87f/channe/12
    let chunks = [CHANNELS, channelId, AGENDAS];
    const endpoint = chunks.join("/");
    const res = await client.get(`${endpoint}`);
    return res.data;
};
export const getEventAgenda = async (eventId, params) => {
    const query = params ? "?" + buildQuery(params) : "";
    let chunks = [EVENTS, eventId, AGENDAS];
    const endpoint = chunks.join("/");
    const res = await client.get(`${endpoint}${query}`);
    return _.get(res, "data.data");
};
export const sortAgenda = async (episodeId, positions) => {
    const endpoint = [EPISODES, episodeId, AGENDAS, SORT].join("/");
    const res = await client.post(`${endpoint}`, {
        positions,
    });
    return _.get(res, "data.data");
};
export const changeOrderdAgenda = async (eventId, order) => {
    const endpoint = [EVENTS, eventId, AGENDAS, CHANGE_ORDER].join("/");
    const res = await client.post(`${endpoint}`, order);
    return res.data;
};

export const deleteAgenda = async (eventId, agendaId, params) => {
    const query = params ? "?" + buildQuery(params) : "";
    const endpoint = [EVENTS, eventId, AGENDAS, agendaId].join("/");
    const res = await client.delete(`${endpoint}${query}`);
    return res.data;
};

export const toggleAgenda = async (channelId, agendaId, params) => {
    const query = params ? "?" + buildQuery(params) : "";
    const endpoint = [CHANNELS, channelId, AGENDAS, agendaId, TOGGLE].join("/");
    const res = await client.post(`${endpoint}${query}`);
    return res.data;
};

// Speaker
export const getSpeakers = async (params, deflate) => {
    let queryPieces = params;
    if (deflate) {
        queryPieces = {
            ...queryPieces,
            mode: "deflate",
        };
    }
    const query = params ? "?" + buildQuery(queryPieces) : "";
    let chunks = [SPEAKERS];
    const endpoint = chunks.join("/");
    const res = await client.get(`${endpoint}${query}`);
    return res.data;
};
export const getSpeakersList = async (params) => {
    const query = params ? "?" + buildQuery(params) : "";
    let chunks = [SPEAKERS];
    const endpoint = chunks.join("/");
    const res = await client.get(`${endpoint}${query}`);
    return res.data;
};
export const getSpeaker = async (speakerId) => {
    ///events/927c6653-bce8-421f-a430-70db32cba87f/channe/12
    let chunks = [SPEAKERS, speakerId];
    const endpoint = chunks.join("/");
    const res = await client.get(`${endpoint}`);
    return res.data;
};

// Calendars

export const getCalendar = async (id) => {
    const res = await client.get([CALENDARS, id].join("/"));
    return _.get(res, "data.data");
};
export const getEventCalendars = async (eventId, params) => {
    const query = params ? "?" + buildQuery(params) : "";
    const url = [EVENTS, eventId, CALENDARS].join("/");
    const res = await client.get(`${url}${query}`);
    return _.get(res, "data.data");
};
export const getEventCalendar = async (eventId, id) => {
    const res = await client.get([EVENTS, eventId, CALENDARS, id].join("/"));
    return _.get(res, "data.data");
};
export const getEventCalendarByType = async (
    eventId,
    calendarType,
    episodeId
) => {
    const query = calendarType
        ? "?" +
        buildQuery({
            type: calendarType,
            episode_id: episodeId,
        })
        : "";
    const res = await client.get(
        [EVENTS, eventId, CALENDARS].join("/") + query
    );
    return _.get(res, "data.data");
};
export const getCertificateCalendars = async ({
    calendarType,
    certificateId,
}) => {
    const query = calendarType
        ? "?" +
        buildQuery({
            type: calendarType,
        })
        : "";
    const res = await client.get(
        [CERTIFICATES, certificateId, CALENDARS].join("/") + query
    );
    return _.get(res, "data.data");
};
export const deleteEventCalendarByType = async (eventId, calendarId) => {
    const res = await client.delete(
        [EVENTS, eventId, CALENDARS, calendarId].join("/")
    );
    return res.data;
};

export const deleteCalendars = async (calendarsId) => {
    const query = calendarsId
        ? "?" +
        buildQuery({
            ids: calendarsId,
        })
        : "";
    const res = await client.delete([CALENDARS].join("/") + query);
    return res.data;
};

export const getEventReminders = async (eventId, params) => {
    const query = params ? "?" + buildQuery(params) : "";
    const res = await client.get(
        [EVENTS, eventId, REMINDERS].join("/") + query
    );
    return _.get(res, "data.data");
};

export const deleteReminder = async (eventId, reminderId) => {
    const endpoint = [EVENTS, eventId, CALENDARS, reminderId].join("/");
    const res = await client.delete(`${endpoint}`);
    return res.data;
};

export const confirmReminder = async (eventId, reminderId) => {
    const endpoint = [EVENTS, eventId, CALENDARS, reminderId].join("/");
    const res = await client.put(`${endpoint}`, {
        confirmed: 1,
    });
    return res.data;
};

export const addSubscribersToReminder = async ({
    reminderId,
    subscriptions,
}) => {
    const endpoint = [CALENDARS, reminderId, CUSTOM_SUBSCRIPTIONS_LIST].join(
        "/"
    );
    const res = await client.post(`${endpoint}`, { subscriptions });
    return res.data;
};

export const resetReminderSubscribers = async ({ reminderId }) => {
    const endpoint = [CALENDARS, reminderId, CUSTOM_SUBSCRIPTIONS_LIST].join(
        "/"
    );
    const res = await client.post(`${endpoint}`, { reset: 1 });
    return res.data;
};

export const testReminder = async ({ eventId, episodeId, params }) => {
    const endpoint = [EVENTS, eventId, EPISODES, episodeId, TEST_REMINDER].join(
        "/"
    );
    const res = await client.post(`${endpoint}`, {
        ...params,
    });
    return res.data;
};

export const loadConnectedUsers = async (eventId, episodeId, params) => {
    const endpoint = [
        EVENTS,
        eventId,
        EPISODES,
        episodeId,
        UPDATE_CONNECTED_USERS,
    ].join("/");
    const res = await client.post(`${endpoint}`, {
        ...params,
    });
    return res.data;
};

// Themes
// getEligibleThemes
export const getEventThemes = async (eventId) => {
    const query = "";
    // const query = (calendarType) ? "?" + buildQuery({
    //     type: calendarType
    // }) : "";
    const res = await client.get([EVENTS, eventId, THEMES].join("/") + query);
    return _.get(res, "data.data");
};

export const getTheme = async (themeId) => {
    const res = await client.get([THEMES, themeId].join("/"));
    return _.get(res, "data.data");
};

export const setEventThemeVersion = async ({ eventId, themeVersion }) => {
    const res = await client.put(
        [EVENTS, eventId, SET_THEME_VERSION].join("/"),
        {
            version: themeVersion,
        }
    );
    return _.get(res, "data.data");
};

export const publishEventThemeChanges = async ({ eventId }) => {
    const res = await client.put(
        [EVENTS, eventId, PUBLISH_THEME_CHANGES].join("/")
    );
    return _.get(res, "data.data");
};

export const resetEventThemeChanges = async ({ eventId }) => {
    const res = await client.put(
        [EVENTS, eventId, RESET_THEME_CHANGES].join("/")
    );
    return _.get(res, "data.data");
};

// Legal
export const getEventLegals = async (eventId) => {
    const url = [EVENTS, eventId, LEGALS].join("/");
    const res = await client.get(url);
    return _.get(res, "data.data");
};

export const getLegal = async (legalId) => {
    const url = [LEGALS, legalId].join("/");
    const res = await client.get(url);
    return _.get(res, "data.data");
};

export const deleteLegal = async (eventId, legalId) => {
    const endpoint = [EVENTS, eventId, LEGALS, legalId].join("/");
    const res = await client.delete(`${endpoint}`);
    return res.data;
};

// Mailers
export const getEventMailers = async (eventId) => {
    const url = [EVENTS, eventId, MAILERS].join("/");
    const res = await client.get(url);
    return _.get(res, "data.data");
};

// FAQs
export const getEventFaqs = async (eventId) => {
    const res = await client.get([EVENTS, eventId, FAQS].join("/"));
    return _.get(res, "data.data");
};
export const deleteFaq = async (eventId, itemId) => {
    const endpoint = [EVENTS, eventId, FAQS, itemId].join("/");
    const res = await client.delete(`${endpoint}`);
    return res.data;
};

// Subscriptions
export const getSubscriptionsList = async (eventId, params) => {
    const query = params ? "?" + buildQuery(params) : "";
    let chunks = [EVENTS, eventId, SUBSCRIPTIONS];
    const endpoint = chunks.join("/");
    const res = await client.get(`${endpoint}${query}`);
    return res.data;
};

export const sendRegistrationEmail = async (eventId, params) => {
    let chunks = [EVENTS, eventId, SUBSCRIPTIONS, SEND_REGISTRATION_EMAIL];
    const endpoint = chunks.join("/");
    const res = await client.post(`${endpoint}`, params);
    return res.data;
};
export const deleteSubscriptions = async (eventId, params) => {
    const query = params ? "?" + buildQuery(params) : "";
    let chunks = [EVENTS, eventId, SUBSCRIPTIONS];
    const endpoint = chunks.join("/");
    const res = await client.delete(`${endpoint}${query}`);
    return res.data;
};

export const exportSubscriptions = async (eventId, params = {}) => {
    const query = buildQuery(params);
    const endpoint = [EVENTS, eventId, EXPORT_SUBSCRIPTIONS].join("/");
    const res = await client.get(`${endpoint}?${query}`, {
        responseType: "blob",
    });
    return res.data;
};

export const exportLogins = async (eventId, params = {}) => {
    const query = buildQuery(params);
    const endpoint = [EVENTS, eventId, EXPORT_LOGINS].join("/");
    const res = await client.get(`${endpoint}?${query}`, {
        responseType: "blob",
    });
    return res.data;
};

export const subscriberToChannels = async (eventId, params) => {
    const endpoint = createUrl([EVENTS, eventId, SUBSCRIBE_TO_CHANNELS]);
    const res = await client.post(`${endpoint}`, params);
    return res.data;
};

export const changeSubscriptionType = async (eventId, params) => {
    const endpoint = createUrl([EVENTS, eventId, CHANGE_SUBSCRIPTION_TYPE]);
    const res = await client.post(`${endpoint}`, params);
    return res.data;
};

export const forceUsersLogout = async (eventId, params) => {
    const endpoint = createUrl([EVENTS, eventId, FORCE_USERS_LOGOUT]);
    const res = await client.post(`${endpoint}`, params);
    return res.data;
};

export const getSubscriptionAnalytics = async (eventId, subscriptionId) => {
    const endpoint = createUrl([
        EVENTS,
        eventId,
        SUBSCRIPTIONS,
        subscriptionId,
        SUBSCRIPTION_ANALYTICS,
    ]);
    const res = await client.get(`${endpoint}`);
    return window._.get(res, "data.data");
};

// Share
export const shareEvent = async (eventId, params) => {
    const endpoint = createUrl([EVENTS, eventId, SHARE]);
    const res = await client.post(`${endpoint}`, params);
    return res.data;
};

// Delete
export const deleteEvents = async (eventIds, params) => {
    consoleLog("eventIds", eventIds);
    params = {
        ...(params || {}),
        ids: eventIds,
    };
    const endpoint = createUrl([EVENTS]);
    consoleLog("eventIds", params);
    const res = await client.delete(`${endpoint}`, {
        data: params,
    });
    return res.data;
};

// Import
export const importSubscriptions = async (eventId, params) => {
    const url = [EVENTS, eventId, IMPORT_SUBSCRIPTIONS].join("/");
    const res = await client.post(url, params);
    return _.get(res, "data");
};
export const getImports = async (eventId, params) => {
    const url = [EVENTS, eventId, IMPORTS].join("/");
    const res = await client.get(url, params);
    return _.get(res, "data");
};

// reports
export const getStaticReports = async (eventId, episodeId) => {
    // const query = buildQuery({
    //     episode_id: episodeId
    // });
    const url = [EVENTS, eventId, EPISODES, episodeId, REPORTS].join("/");
    const res = await client.get(`${url}`);
    return _.get(res, "data.data");
};

export const refreshStaticReports = async (eventId, episodeId, params) => {
    // const query = buildQuery({
    //     episode_id: episodeId
    // });
    const url = [EVENTS, eventId, EPISODES, episodeId, REFRESH_REPORTS].join(
        "/"
    );
    const res = await client.post(`${url}`, params);
    return _.get(res, "data.data");
};

export const downloadStaticReports = async (eventId, episodeId, reportId) => {
    const query = reportId
        ? "?" +
        buildQuery({
            report_id: reportId,
        })
        : "";
    const url = [EVENTS, eventId, EPISODES, episodeId, DOWNLOAD_REPORTS].join(
        "/"
    );
    const res = await client.get(`${url}${query}`, {
        responseType: "blob",
    });

    return _.get(res, "data");
};

// Questions categories
export const getEvaluationquestionsCategories = async (eventId, episodeId) => {
    const query = buildQuery({
        episode_id: episodeId,
    });
    const url = [EVENTS, eventId, EVALUATIONQUESTIONSCATEGORIES].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data.data");
};

export const getEvaluationquestionsCategory = async (eventId, categoryId) => {
    const url = [
        EVENTS,
        eventId,
        EVALUATIONQUESTIONSCATEGORIES,
        categoryId,
    ].join("/");
    const res = await client.get(url);
    return _.get(res, "data.data");
};

export const deleteEvaluationquestionsCategory = async (
    eventId,
    categoryId
) => {
    const url = [
        EVENTS,
        eventId,
        EVALUATIONQUESTIONSCATEGORIES,
        categoryId,
    ].join("/");
    const res = await client.delete(url);
    return _.get(res, "data");
};

// Config
export const exportEventConfigList = async (eventId, params) => {
    const query = buildQuery(params);
    const url = [EXPORT_CONFIG].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data.data");
};
export const importEventConfig = async (eventId, params) => {
    // const query = buildQuery({
    //     episode_id: episodeId
    // });
    const url = [EVENTS, eventId, IMPORT_CONFIG].join("/");
    const res = await client.post(`${url}`, params);
    return _.get(res, "data.data");
};
export const importEvent = async (params) => {
    const url = [EVENTS, IMPORT].join("/");
    const res = await client.post(`${url}`, params);
    return _.get(res, "data.data");
};


export const getEmailSuppressionList = async () => {
    const url = [LOGS, SUPPRESSION_LIST].join("/");
    const res = await client.get(`${url}`);
    return _.get(res, "data.data");
};

export const getAdminAccessLogList = async (params) => {
    const query = buildQuery(params);
    const url = [LOGS, ADMIN_ACCESS_LOG].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getCertificateLogList = async (params) => {
    const query = buildQuery(params);
    const url = [LOGS, CERTIFICATE_LOG].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};
export const getCertificateReportsList = async ({
    eventId,
    episodeId,
    certificateId,
    filters,
}) => {
    const query = buildQuery(filters);
    //events/{{event_id}}/episodes/{{episode_id}}/certificates-logs/1
    let chuncks = [EVENTS, eventId, EPISODES, episodeId, CERTIFICATE_LOG];

    if (certificateId) {
        chuncks.push(certificateId);
    }

    const url = chuncks.join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getForcedLogoutLogList = async (params) => {
    const query = buildQuery(params);
    const url = [LOGS, FORCED_LOGOUT_LOG].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getCalendarLogList = async (params) => {
    const query = buildQuery(params);
    const url = [LOGS, CALENDAR_LOG].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getRegistrationEmailLogList = async (params) => {
    const query = buildQuery(params);
    const url = [LOGS, REGISTRATION_EMAIL_LOG].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getErrorLogList = async (params) => {
    const query = buildQuery(params);
    const url = [LOGS, ERROR_LOG].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getQueueErrorLogList = async (params) => {
    const query = buildQuery(params);
    const url = [LOGS, JOBS_ERROR_LOG].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getActivityLogList = async (params) => {
    const query = buildQuery(params);
    const url = [LOGS, BLACKBOX].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getAdminLoginLogList = async (params) => {
    const query = buildQuery(params);
    const url = [LOGS, USER_LOGIN_LOG].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getEmailHistoryLogList = async (params) => {
    const query = buildQuery(params);
    const url = [LOGS, EMAIL_HISTORY_LOG].join("/");
    const res = await client.get(`${url}?${query}`);
    return _.get(res, "data");
};

export const getAdamEndpointsList = async () => {
    const url = [ROUTES_LIST].join("/");
    const res = await client.get(`${url}`);
    return _.get(res, "data");
};

export const refreshToken = async () => {
    const url = [REFRESH_TOKEN].join("/");
    const res = await client.get(`${url}`);
    return _.get(res, "data");
};

// DOWNLOADABLE
export const getDownloadableItems = async (episodeId) => {
    const url = [EPISODES, episodeId, DOWNLOADABLE].join("/");
    const res = await client.get(`${url}`);
    return _.get(res, "data.data");
};

export const sortDownloadableItems = async (episodeId, positions) => {
    const endpoint = [EPISODES, episodeId, DOWNLOADABLE, SORT].join("/");
    const res = await client.post(`${endpoint}`, {
        positions,
    });
    return _.get(res, "data.data");
};

export const deleteDownloadableItem = async (episodeId, downloadItemId) => {
    const url = [EPISODES, episodeId, DOWNLOADABLE, downloadItemId].join("/");
    const res = await client.delete(`${url}`);
    return _.get(res, "data");
};

/**
 * Config
 */
export const getConfigsEnum = async () => {
    const url = [CONFIGS, ENUM].join("/");
    const res = await client.get(`${url}`);
    return _.get(res, "data");
}

export const getConfigs = async () => {
    const url = [CONFIGS].join("/");
    const res = await client.get(`${url}`);
    return _.get(res, "data");
}

export const createConfig = async (params) => {
    const url = [CONFIGS].join("/");
    const res = await client.post(`${url}`, params);
    return _.get(res, "data");
}

export const updateConfig = async (configKey, params) => {
    const url = [CONFIGS, configKey].join("/");
    const res = await client.put(`${url}`, params);
    return _.get(res, "data");
}

export const deleteConfig = async (configKey) => {
    const url = [CONFIGS, configKey].join("/");
    const res = await client.delete(`${url}`);
    return _.get(res, "data");
}

export const getNotifications = async () => {
    const url = [NOTIFICATIONS].join("/");
    const res = await client.get(`${url}`);
    return _.get(res, "data");
}

export const readNotifications = async (params) => {
    const url = [NOTIFICATIONS, params].join("/");
    const res = await client.post(`${url}`, params);
    return _.get(res, "data");
}

export const eventHistoryDownload = async (eventId, params) => {
    const url = [EVENTS, eventId, ACTIVITY_LOGS, DOWNLOAD].join("/");
    const res = await client.get(`${url}`, {
        responseType: "blob"
    });
    return res.data;
}

export const addSubscriberNotificationsCalendar = async (episodeId, params) => {
    const endpoint = [SUBSCRIBER_NOTIFICATIONS, episodeId, CALENDARS].join("/");
    const res = await client.post(`${endpoint}`, {
        params,
    });
    return _.get(res, "data.data");
}

export const getSubscriberNotificationsCalendar = async (notificationId, params) => {
    const query = buildQuery(params);
    const url = [SUBSCRIBER_NOTIFICATIONS, notificationId, CALENDARS].join("/");
    const res = await client.get(`${url}?${query}`)
    return _.get(res, "data.data");
}

export const getSubscriberNotifications = async (episodeId) => {
    const url = [EPISODES, episodeId, SUBSCRIBER_NOTIFICATIONS].join("/");
    const res = await client.get(`${url}`)
    return _.get(res, "data.data");
}

export const createSubscriberNotification = async (episodeId, params) => {
    const endpoint = [EPISODES, episodeId, SUBSCRIBER_NOTIFICATIONS].join("/");
    const res = await client.post(`${endpoint}`, {
        params,
    });
    return _.get(res, "data.data");
}

export const putSubscriberNotification = async (notificationId, params) => {
    const endpoint = [SUBSCRIBER_NOTIFICATIONS, notificationId].join("/");
    const res = await client.put(`${endpoint}`, {
        params,
    });
    return _.get(res, "data.data");
}

export const deleteSubscriberNotification = async (notificationId, params) => {
    const endpoint = [SUBSCRIBER_NOTIFICATIONS, notificationId].join("/");
    const res = await client.delete(`${endpoint}`, {
        params,
    });
    return _.get(res, "data");
}

export const postSubscriberNotificationSubscriberList = async (subscriberNotificationId, params) => {
    const endpoint = [SUBSCRIBER_NOTIFICATIONS, subscriberNotificationId, CUSTOM_SUBSCRIPTIONS_LIST].join("/");
    const res = await client.post(`${endpoint}`, {
        ...params,
    });
    return _.get(res, "data.data");
}

// Storable
const getStorable = async (name, force) => {
    const storage = localStorage.getItem(name);
    if (storage && !force) {
        return Promise.resolve().then(function () {
            return JSON.parse(storage);
        });
    }
    const res = await client.get(name);
    const data = _.isEmpty(res.data) ? null : res.data;
    localStorage.setItem(name, JSON.stringify(data));
    return res.data;
};

const createUrl = (chunks) => {
    return chunks.join("/");
};
